import { useOverlayPresence } from '../lib/overlayGate'

/** Маркер оверлея для компонентов с ранними return: кладётся внутрь корня оверлея. */
export function OverlayPresence({ name }: { name: string }) {
  useOverlayPresence(name)
  return null
}
